import React, {Suspense} from 'react'
import Divider from '@components/V3/Divider'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'
import useWebsiteId from '@hooks/useWebsiteId'
import formatNumber from '@i18n/formatNumber'
import WebsiteCoinsImage from '@page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useTranslation} from 'next-i18next'

function PointsInner() {
  const websiteId = useWebsiteId()
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'summary'})
  const isDarkMode = useIsDarkMode()

  const {preferences} = useQuery({
    query: gql`
      query CheckoutV3GetPoints($websiteId: ID!) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          cart {
            pointsDetails {
              amount
              name
            }
          }
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first'
  })
  const {pointsDetails} = preferences?.cart
  if (!pointsDetails) return null

  const {name, amount} = pointsDetails

  if (!amount) return null

  return (
    <div>
      <Divider full />
      <div
        className={classnames({
          'flex justify-center items-center space-x-2 pt-2 md:pt-4': true,
          'text-gray-500': !isDarkMode,
          'text-gray-300': isDarkMode
        })}>
        <WebsiteCoinsImage svgClass="primaryColor" />
        <span className="text-sm">
          {t('purchaseAccumulation')}{' '}
          <strong>
            {t('pointsAmount', {pointsAmount: formatNumber(amount, '0,0.[00]'), pointsName: name})}
          </strong>
        </span>
      </div>
      <Divider full />
    </div>
  )
}

export default function Points() {
  return (
    <Suspense fallback={null}>
      <PointsInner />
    </Suspense>
  )
}
